export * from "./PrivacyPolicy";
export * from "./Landing";
export * from "./NewsUpdatePricing";
export * from "./SpecifiedCommercialTransactionLaw";
export * from "./Terms";
